export const fillToParent = {
  width: '100%',
  height: '100%',

  top: 0,
  right: 0,
  left: 0,
  bottom: 0,
};

export const absoluteCenter = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate3d(-50%, -50%, 0)',
};

export const textOverflowEllipsis = {
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
};

export const scroll = {
  overflow: 'auto',
  WebkitOverflowScrolling: 'touch',
};



// WEBPACK FOOTER //
// ./src/styles/mixins.js